import React, { useCallback } from 'react'
import TextButton from 'components/Luxkit/Button/TextButton'
import { ValidHotelInstantBookingCheckoutSchema } from 'checkout/lib/utils/misc/deepLinkUtils'
import { dateDifference } from 'lib/dateUtils'
import { fireABTestGAEvent } from 'api/googleTagManager'
import { reserveNowButtonTestClick, viewOfferTestClick } from 'analytics/eventDefinitions'
import InlineGroup from 'components/Common/InlineGroup/InlineGroup'

interface Props {
    filters: App.OfferListFilters;
    bestPricePackage: App.Package
    className?: string;
}

function ReserveNowTileButton({ filters, bestPricePackage, className }: Props) {
  const duration = dateDifference(new Date(filters.checkOut), new Date(filters.checkIn)).days

  const item: ValidHotelInstantBookingCheckoutSchema = {
    itemType: 'hotel',
    packageId: bestPricePackage.id,
    roomRateId: bestPricePackage.roomRate.id,
    offerId: bestPricePackage.offerId,
    duration,
    reservationType: 'instant_booking',
    checkIn: filters.checkIn,
    checkOut: filters.checkOut,
    occupancy: { adults: 2, children: 0, infants: 0, childrenAge: [] },
    flightBasePrice: 0,
    isBundled: false,
  }

  const encodedItems = encodeURIComponent(JSON.stringify([item]))
  const bookingLink = `/checkout-deep-link?items=${encodedItems}`

  const handleReserveNowTestClick = useCallback(() => {
    fireABTestGAEvent(reserveNowButtonTestClick(), false)
  }, [])

  const handleViewOfferTestClick = useCallback(() => {
    fireABTestGAEvent(viewOfferTestClick(), false)
  }, [])

  return (
    <InlineGroup equal spacing="lg" className={className}>
      <TextButton kind="secondary" onClick={handleViewOfferTestClick}>View offer</TextButton>
      <TextButton kind="primary" to={bookingLink} onClick={handleReserveNowTestClick}>Reserve now</TextButton>
    </InlineGroup>
  ) }

export default ReserveNowTileButton
